/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Appointment Notification View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AppointmentNotificationView';

export const mapStateToPropsAppointmentNotification = mapStateToProps;
export const mapDispatchToPropsAppointmentNotification = mapDispatchToProps;

export default connect(
  mapStateToPropsAppointmentNotification,
  mapDispatchToPropsAppointmentNotification
)(View);
